import { Outlet } from 'react-router-dom';

export const FormDocumentLink = (): JSX.Element => {
  return <Outlet />;
};
